export const isGifFile = (file: File) => file.type.includes('gif');
